import type { GCColor } from '@components/atoms/gccolors';

export const IconSizes = {
    // consult with design before adding new sizes
    xxlarge: 115,
    xlarge: 96,
    large: 48,
    medium: 32,
    small: 24,
    /**
     * Design confirmed 20px belongs in the scale, but the t-shirt names have no room between
     * `small` and `xsmall`, and renumbering either one would move every existing caller. So it
     * deliberately carries the semantic name the Themed Icon will use. That way it stands out as
     * the one entry that does not belong on this scale and gets deleted once that component exists.
     */
    'sizing-5x': 20,
    xsmall: 16,
    xxsmall: 12,
};

export type IconSize = keyof typeof IconSizes;

/**
 * `currentColor` makes the icon take the `color` of whatever renders it. A themed component can
 * then let its icons follow its own text color in every state, instead of the caller naming a
 * palette color for each one. This is a workaround until we create a Themed Icon.
 */
export type IconFill = GCColor | 'currentColor';

export interface IconProps {
    fill?: IconFill;
    stroke?: GCColor;
    size?: IconSize;
    width?: number;
    height?: number;
    className?: string;
}
